    import axios from "axios";//导入axios
	import { Toast } from 'vant';//导入vant toast
	import { Dialog } from 'vant';
	import wxLogin from './wx-login.js'//导入微信登录
	let toast //定义变量toast
		
	//配置全局公共域名
	const baseURL ="https://kaifa.sxgongqiu.com";//测试
	//const baseURL ="https://formal.sxgongqiu.com";
	//创建axios实例 
	let request = axios.create({
		baseURL:baseURL,    //赋值公共域名
		timeout:10000,      //设置延迟时间（单位：毫秒）
		responseType: "json",
	})
	//拦截request的发送请求和响应请求，并做一定的配置	
	request.interceptors.request.use(function(config){
		//拦截发送请求，并给请求头信息headers加上token令牌
		if(localStorage.getItem('token')){
			 config.data.token = localStorage.getItem('token'); 			  
		}
		//config.data.token = "Nl_CKk-CRgujPNmR5f94S38xHPY2s0s7W3OoQTShPddQ-ORxzsOnZBEERC0iYvEpjliDKUSmvyT2OmgHDMNH63Q3np_JE0ofKMxh0JcOQyejBS_JVxWBmgPFSTQCtVuN";
		config.data.device_id='2021WAP';
	    config.data.time_tag=new Date().getTime();
		config.data.app_type='group_h5';
		// config.data.sign=md5Libs.md5(signStr+midStr+time_tag+device_id);
	   return config;
	   
	},function(err){
	   return Promise.reject(err);
	});	
	request.interceptors.response.use(function (response) {
	   //拦截响应请求 ，这里直接返回数据
	   if(response.data.code != 1) {
		   // toast= Toast(response.data.msg)//如果code不等于1时,弹出报错信息		   
		   if(response.data.code == 100000){
			   //如果code等于100000时，需要用户登录
			  
			   Dialog.confirm({
			     title: '未登录',
			     message: '您需要登录才能查看,是否登录?',
			   })
			     .then(() => {
			       wxLogin();				   
			     })
			     .catch(() => {
			       
			     });
		   }
		   else{
			   Dialog.alert({
			     message: response.data.msg,
			   })
			     .then(() => {
			       
			     })
			     .catch(() => {
			       
			     });
		   }
		   
		   return Promise.reject(response); 
	   }  
	   return response;
	}, function (err) {
	    // 对响应错误做点什么
		console.log(err)
		return Promise.reject(err);    
	});
	
	// 给axios实例对象request添加postURL方法
    request.postURL = function(url,data,option={}){
        //返回一个promise，实现异步处理
        return new Promise(function(resolve,reject){
            request({
                url:url,
                method:"POST",
				data:data,
                ...option,
            })
            .then(res=>resolve(res))
            .catch(err=>reject(err))
        })
    }
	//导出request
	export default request;